import { AssetsPoUnitRequest, ErrorResponse } from '@gtpl/shared-models/common-models';
import { VendorDropDownDto } from '@gtpl/shared-models/masters';
import { AllAssetsPoDetailsInfo, GetAllAssetsPoResponse } from '@gtpl/shared-models/procurement-management';
import { PaymentTermsService, VendorsService } from '@gtpl/shared-services/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { AssetsPo } from './assets-po-entity';
import { AssetsPoAdapter } from './dto/assets-po-adpater';
import { AssetsPoDtO } from './dto/assets-po-dto';
import { AssetsPoRepository } from './dto/assets-po-repository';

@Injectable()
export class AssetsPoService {

    constructor(private adpater: AssetsPoAdapter,  private vendorService: VendorsService, private paymentTermsService: PaymentTermsService, @InjectRepository(AssetsPo)
    private repository: Repository<AssetsPo>) { }
    // async CreateAssets(poData: AssetsPoDtO, isUpdate?: boolean) {
    //     // const convertedEntity = this.adpater.convertDtoToEntity(poData, currentFinancialYear, isUpdate);
    //     const response = await this.repository.save(convertedEntity);
    // }

    async getAllAssetsPo() {
        return await this.repository.find();
    }

    async getRecordByAssetsPoId(id: number) {
        return await this.repository.findOne({ where: { purchaseOrderId: id } });
    }

    async getAllAssetsPoDetailsInfo(req: AssetsPoUnitRequest): Promise<GetAllAssetsPoResponse> {
        const poEntities: AssetsPo[] = await this.repository.find({
            where: { unitId: req.unitId },
            order: { createdAt: "DESC" },
        });

        if (poEntities && poEntities.length > 0) {
            const poInfo: AllAssetsPoDetailsInfo[] = [];
            for (const po of poEntities) {
                
                let vendorDetails = await this.vendorService.getVendorDataById({ vendorId: po.vendorName });

                const vendor = new VendorDropDownDto(vendorDetails.data.vendorId, vendorDetails.data.vendorName);

                let paymentTermsDetails = await this.paymentTermsService.getPaymentById({ paymentTermsId: po.paymentTerms })

                let paymentTermsName = '';
                if (paymentTermsDetails.status) {
                    paymentTermsName = paymentTermsDetails.data.paymentTermsName;
                }


                const poData = new AllAssetsPoDetailsInfo( vendor, po.poNumber, po.purchaseOrderDate, po.totalTransportation, po.expectedDeliveryDate, po.deliveryAddress, po.paymentTerms, po.remarks, po.note, po.createdUser, po.updatedUser,  po.purchaseOrderId, po.status, po.poType, '');
                poInfo.push(poData);
            }
            return new GetAllAssetsPoResponse(true, 1525, 'AssetsPo Details Retrieved Successfully', poInfo);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

}
